import React from 'react';
import './AppFooter.scss';

export class AppFooter extends React.Component {
  render() {
    const year = new Date().getFullYear();
    return (
      <div className='app-footer'>
        <div>
          {year} &copy; {process.env.REACT_APP_VERSION}
          <br />
          powered by TenMax
          <br />
        </div>
      </div>
    );
  }
}
